import { ReactNode } from "react";
import { FormattedMessage } from "react-intl";
import {
  CardHeader,
  CardTitle,
  EditButton,
  EditIcon,
  ReviewCardStyled,
  Rows,
} from "./styles";

export interface ReviewCardProps {
  titleId: string;
  titleDefault: string;
  /** Localised aria-label for the pencil button. */
  editLabel: string;
  onEdit: () => void;
  "data-testid": string;
  children: ReactNode;
}

/**
 * An editable review card (reuses CardContainer): a title, a pencil that jumps
 * back to the related step, and value rows.
 */
export const ReviewCard = ({
  titleId,
  titleDefault,
  editLabel,
  onEdit,
  "data-testid": testId,
  children,
}: ReviewCardProps) => (
  <ReviewCardStyled data-testid={testId}>
    <CardHeader>
      <CardTitle>
        <FormattedMessage id={titleId} defaultMessage={titleDefault} />
      </CardTitle>
      <EditButton
        type="button"
        aria-label={editLabel}
        data-testid={`${testId}-edit`}
        onClick={onEdit}
      >
        <EditIcon name="edit" aria-hidden />
      </EditButton>
    </CardHeader>
    <Rows>{children}</Rows>
  </ReviewCardStyled>
);
